import React, { useContext } from 'react';

import AppContext, { AppContextType } from '../../context/AppContext';

import styles from './Multilanguage.module.scss';

interface LanguageWithFlag {
    url: string;
    label: string;
    selected: boolean;
    locale: string;
}

export function getLanguageWithFlags(
    availableLanguages: AppContextType['availableLanguages'],
    contentCDN: string,
): LanguageWithFlag[] {
    return availableLanguages.map(({ selected, locale }) => {
        const lang = locale.split('-')[0];
        return {
            url: `${contentCDN}/media/ui-components/v6-latest/png/country-flags/1x1/${lang}.png`,
            label: lang.toUpperCase(),
            selected,
            locale,
        };
    });
}

export function LanguageWithFlag({ url, label }: LanguageWithFlag) {
    const { translations } = useContext(AppContext);
    const accessibleText = translations
        .get('shop.header.multilanguage.accessible.text')
        ?.replace('${language}', label);
    return (
        <div className={styles.languageFlag} data-zta="language-flag">
            <span
                className={styles.languageFlagLabel}
                data-zta="language-label">
                {label}
            </span>
            <img
                data-zta="language-flag-image"
                className={styles.languageFlagImage}
                src={url}
                width="16"
                alt={accessibleText}
            />
        </div>
    );
}
